// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3XSCB","file":"styles_file__19MMs"};